<template>
  <div class="order-give-info">
    <!-- <div class="order-detail-item order-detail-status">
      <div class="order-detail-audit-status">
        <div class="color-black bold">订单审核状态：待审核</div>
      </div>
    </div> -->
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        学员信息
      </div>
      <div class="order-detail-student">
        <div class="order-detail-people-name">
          <span
            class="order-detail-student-name"
          >学员姓名： {{ orderDetail.child_info.child_name }}</span>
          <span>就读小学：{{ orderDetail.child_info.school_name }}</span>
          <span>就读年级：{{ orderDetail.child_info.grade_name }}</span>
        </div>
        <div class="order-detail-people-name">
          <span
            class="order-detail-student-name"
          >家长姓名：{{ orderDetail.child_info.parent_name }}</span>
          <span>家长电话：{{ orderDetail.child_info.mobile }}</span>
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        套餐信息
      </div>
      <div class="order-detail-package">
        <div class="order-refund-list">
          <div class="order-detail-people-name">
            <span>套餐名称：{{ orderDetail.item_name }}</span>
          </div>
          <el-table :data="orderDetail.sku_set">
            <el-table-column prop="summary" label="类型" />
            <el-table-column
              prop="days"
              label="赠送课时课时（天）"
            />
          </el-table>
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        订单信息
      </div>
      <div class="order-detail-package">
        <div>签约单号：{{ orderDetail.billing_info.selling_billing_yuid }}</div>
        <div>赠送类型：{{ orderDetail.billing_info.give_type_name }}</div>
        <div>
          赠送原因：{{ orderDetail.billing_info.extra.headmaster_remark }}
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        销售信息
      </div>
      <div class="order-detail-sales">
        <div class="order-detail-people-name">
          <span>提交人：{{ orderDetail.billing_info.editor_name }}</span>
          <span>班主任：{{ orderDetail.billing_info.headmaster_name }}</span>
        </div>
      </div>
    </div>
    <div class="order-audit-btn">
      <el-row type="flex" justify="end">
        <el-button type="primary" @click="auditSuccess">审核成功</el-button>
      </el-row>
      <el-row type="flex" justify="end">
        <el-input
          v-model="message"
          clearable
          placeholder="请输入失败原因"
        />
        <el-button type="info" @click="auditFail">审核失败</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderGiveInfo',
  props: {
    orderDetail: Object
  },
  data() {
    return {
      message: ''
    }
  },
  methods: {
    auditSuccess() {
      this.$http
        .auditSuccess({
          billing_id: this.orderDetail.billing_info.selling_billing_yuid
        })
        .then(res => {
          this.$emit('updateOrderList')
        })
    },
    auditFail() {
      if (!this.message) {
        this.$message({
          type: 'info',
          message: '请填写审核失败原因'
        })
        return
      }
      const obj = {
        billing_id: this.orderDetail.billing_info.selling_billing_yuid,
        message: this.message
      }
      this.$http.auditFail(obj).then(res => {
        this.$emit('updateOrderList')
      })
    }
  }
}
</script>

<style lang="scss">
.order-detail-dialog .el-dialog__body {
  height: 700px;
  padding: 20px 30px;
  overflow: auto;
  .order-give-info {
    line-height: 24px;
    .order-detail-item {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
    }
    .order-detail-status {
      padding: 15px 20px;
      background-color: #f5f5f5;
    }
    .order-detail-item-title {
      margin-bottom: 15px;
    }
    .order-detail-people-name span {
      margin-right: 30px;
    }
    .order-detail-student-name {
      width: 160px;
    }
    .el-table {
      margin-top: 10px;
    }
    .el-table tr th {
      height: 34px !important;
      background: #fff !important;
      color: #333;
    }
    .el-table td,
    .el-table th {
      padding: 4px;
      border: 1px solid #f5f5f5;
    }
  }
  .order-audit-btn {
    .el-row {
      margin-bottom: 10px;
    }
    .el-input {
      margin-right: 20px;
    }
  }
  .special-table {
    width: 100%;
    margin: 30px 0;
    border: 1px solid #f5f5f5;
    tr,
    th,
    td {
      text-align: center;
      padding: 10px 0;
      border: 1px solid #f5f5f5;
    }
  }
}
</style>
